import { Doc } from '@dadohr/shared/domainTypes/document';
import { ITimelineItemNote } from '@dadohr/shared/domainTypes/experience';
import { FS } from '@dadohr/shared/versions';
import {
  CollectionListener,
  createCollectionListenerStore,
  useCollectionListener
} from '../firecache/collectionListener';
import { prepareNewDoc, setDoc, store, updateDoc } from '../firebase';
import { now } from '../time';

const DELIMITER = '@@@';

const notesByTemplateAndItemStore = createCollectionListenerStore((key) => {
  const [orgId, experienceTemplateId, itemId] = key.split(DELIMITER);
  return new CollectionListener<ITimelineItemNote>(
    store()
      .collection(FS.timelineItemNotes)
      .where('orgId', '==', orgId)
      .where('experienceTemplateId', '==', experienceTemplateId)
      .where('itemId', '==', itemId)
      .where('deletedAt', '==', null)
      .orderBy('createdAt', 'desc')
  );
});

export const useTimelineItemNotes = (
  orgId: string,
  experienceTemplateId: string,
  itemId: string
) =>
  useCollectionListener(
    notesByTemplateAndItemStore(
      [orgId, experienceTemplateId, itemId].join(DELIMITER)
    )
  );

export const addTimelineItemNote = async (
  orgId: string,
  experienceTemplateId: string,
  itemId: string,
  itemType: ITimelineItemNote['itemType'],
  text: string,
  createdBy: string,
  createdByEmail: string,
  createdByName: string
): Promise<void> => {
  const docRef = prepareNewDoc(FS.timelineItemNotes);
  const note: Doc<ITimelineItemNote> = {
    id: docRef.id,
    collection: FS.timelineItemNotes,
    data: {
      orgId,
      experienceTemplateId,
      itemId,
      itemType,
      text: text.slice(0, 800),
      createdAt: now(),
      createdBy,
      createdByEmail,
      createdByName,
      deletedAt: null,
      deletedBy: null
    }
  };
  await setDoc(note);
};

export const deleteTimelineItemNote = async (
  note: Doc<ITimelineItemNote>,
  deletedBy: string
): Promise<void> => {
  await updateDoc(note, () => ({
    deletedAt: now(),
    deletedBy
  }));
};
